import { render, staticRenderFns } from "./save-template.vue?vue&type=template&id=00ef684e&scoped=true"
import script from "./save-template.vue?vue&type=script&lang=js"
export * from "./save-template.vue?vue&type=script&lang=js"
import style0 from "./save-template.vue?vue&type=style&index=0&id=00ef684e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef684e",
  null
  
)

export default component.exports